import { Plus } from 'lucide-react';
import { useState, type FormEvent, type KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/app/store';
import styles from './QuickAdd.module.css';

export interface QuickAddProps {
  date?: string | null;
  className?: string;
}

export function QuickAdd({ date, className }: QuickAddProps) {
  const { t } = useTranslation();
  const quickAddPlan = useAppStore((s) => s.quickAddPlan);
  const selectedDate = useAppStore((s) => s.selectedDate);
  const [value, setValue] = useState('');

  const targetDate = date !== undefined ? date : selectedDate;

  const submit = async () => {
    const trimmed = value.trim();
    if (!trimmed) return;
    await quickAddPlan(trimmed, targetDate);
    setValue('');
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      void submit();
    }
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    void submit();
  };

  return (
    <form className={`${styles.wrap} ${className ?? ''}`} onSubmit={handleSubmit}>
      <Plus size={14} className={styles.icon} aria-hidden="true" />
      <input
        type="text"
        className={styles.input}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={t('plan.quickPlaceholder')}
        aria-label={t('app.quickAdd')}
      />
    </form>
  );
}
